import { api, APIResponse } from '@/store/api';
import type { AuthenticatorSetup, IsSetup } from '@/types/authenticator.types';

export const authenticatorApi = api.injectEndpoints({
  endpoints: (builder) => ({
    setupAuthenticator: builder.mutation<APIResponse<AuthenticatorSetup>, void>({
      query: () => ({
        url: 'admin/authenticator/setup',
        method: 'POST',
      }),
      invalidatesTags: ['Authenticator'],
    }),

    isAuthenticatorSetup: builder.query<IsSetup, void>({
      query: () => 'admin/authenticator/is-setup',
      transformResponse: (response: APIResponse<IsSetup>) => response.data,
      providesTags: ['Authenticator'],
    }),
  }),
});

export const { useSetupAuthenticatorMutation, useIsAuthenticatorSetupQuery } = authenticatorApi;
